export enum enumImage {
    wpContent = 'wp-content',
}

export const imageDomainToIgnore = ['https://img.shields.io/'];
